<template>
    <div class="footbar">
        <div class="content">
            <div class="box flex_r flex_jb">
                <div class="logo">
                    <img src="@/assets/img/home/img4.png" />
                    <!-- <div class="txt">LeSmart</div> -->
                </div>
                <div class="heading flex_r flex_jb">
                    <div class="item">
                        <div class="tit">{{$t('index.productIntro')}}</div>
                        <div class="txt" @click="togo('product')">Memory Cube</div>
                    </div>
                    <div class="item">
                        <div class="tit">{{$t('index.aiFrame')}}</div>
                        <div class="txt" @click="togo('distribute')">3D AI FRAME</div>
                    </div>
                    <div class="item">
                        <div class="tit">{{$t('index.eLinkFrame')}}</div>
                        <div class="txt" @click="togo('blueframe')">E-INK FRAME</div>
                    </div>
                    <div class="item">
                        <div class="tit">{{$t('index.contactUs')}}</div>
                        <div class="txt" @click="toEmail('home')">{{$t('index.bookConsult')}}</div>
                    </div>
                </div>
                <div class="qrcodes flex_r flex_jb">
                    <div class="item flex_c flex_ac">
                        <img src="@/assets/img2/footbar/app.png" class="appcode">
                        <div class="txt">{{$t('index.scanDownloadApp')}}</div>
                    </div>
                    <!-- <div class="item flex_c flex_ac">
                        <img src="@/assets/img2/footbar/mp.jpg">
                        <div class="txt">{{$t('index.scanMiniProgram')}}</div>
                    </div> -->
                </div>
            </div>
            <div class="infos">
                <!-- <div class="p1 flex_r flex_ac flex_jc">
                    <div class="txt">Copyighte 2024 LeSmart reserved</div>
                    <div class="txt">{{$t('index.privacyPolicy')}}</div>
                    <div class="txt">{{$t('index.userAgreement')}}</div>
                </div> -->
                <div class="p1">Copyright © 2024-2026 乐启智慧科技（深圳）有限公司版权所有</div>
                <!-- <div class="p1">Copyighte 2024-2026 乐启智慧 reserved</div> -->
                <a href="https://beian.miit.gov.cn" target="_blank" class="p1">粤ICP备2023152195号-1 粤公网备案</a>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
export default {
    name: "footbar",
    data() {
        return {};
    },
    created() { },
    mounted() { },
    methods: {
        togo(name) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            EventBus.$emit('changeTab', name);
            this.$router.push(name, () => { }, () => { })
        },
        toEmail(name) {

            EventBus.$emit('changeTab', name);
            EventBus.$emit('toEmail', name);

            this.$router.push(name, () => { }, () => { })
        },
    },
};
</script>

<style lang="scss" scoped>
.footbar {
    width: 100%;
    padding: 36px 0;
    background: #000;
    color: #fff;

    .box {
        .logo {
            img {
                width: 62px;
                height: 98px;
            }

            .txt {
                font-size: 16px;
                font-weight: 600;
                margin-top: 8px;
            }
        }

        .heading {
            .item {
                margin: 0 30px;
                text-align: center;
            }

            .tit {
                font-size: 18px;
            }

            .txt {
                font-size: 14px;
                color: #748EA6;
                line-height: 50px;
                cursor: pointer;
            }
        }

        .qrcodes {
            .item {
                &:last-child{
                    margin-left: 30px;
                }
            }

            .appcode {
                padding: 3px;
                box-sizing: border-box;
                background-color: #fff;
            }

            img {
                width: 108px;
                height: 108px;
            }

            .txt {
                text-align: center;
                font-size: 14px;
                margin-top: 8px;
            }
        }
    }

    .infos {
        color: #748EA6;
        text-align: center;
        font-size: 12px;
        line-height: 22px;
        margin-top: 30px;

        a{
            color: #fff;
        }

        .txt {
            margin: 0 6px;
        }
    }
}
</style>
